import client from './client';
import API_CONFIG from '../config';

// ============ USERS API ============

export const fetchUsers = async (params = {}) => {
  const { page = 1, page_size = 10, role, statut, departement, q } = params;
  const res = await client.get(API_CONFIG.ENDPOINTS.USERS.LIST, { params: { page, page_size, role, statut, departement, q } });
  return res.data;
};

export const fetchUserStats = async () => {
  const res = await client.get(API_CONFIG.ENDPOINTS.USERS.STATS);
  return res.data;
};

export const createUser = async (payload) => {
  const res = await client.post(API_CONFIG.ENDPOINTS.USERS.LIST, payload);
  return res.data;
};

export const updateUser = async (id, payload) => {
  const res = await client.put(`${API_CONFIG.ENDPOINTS.USERS.DETAIL}${id}/`, payload);
  return res.data;
};

export const archiveUser = async (id) => {
  await client.delete(`${API_CONFIG.ENDPOINTS.USERS.DETAIL}${id}/`);
  return true;
};

export const exportUsers = async (params = {}) => {
  const res = await client.get(API_CONFIG.ENDPOINTS.USERS.EXPORT, { params, responseType: 'blob' });
  return res.data;
};

export const createGerant = async (payload) => {
  const res = await client.post(API_CONFIG.ENDPOINTS.USERS.CREATE_GERANT, payload);
  return res.data;
};

// ============ PARTICIPANTS API ============

export const fetchParticipants = async (surveyId = null) => {
  const params = {};
  if (surveyId) {
    params.survey = surveyId;
  }
  try {
    const response = await client.get(API_CONFIG.ENDPOINTS.PARTICIPANTS.LIST, { params });
    // Handle different response formats
    const responseData = response.data;
    if (Array.isArray(responseData)) {
      return responseData;
    } else if (responseData?.data && Array.isArray(responseData.data)) {
      return responseData.data;
    } else if (Array.isArray(responseData?.results)) {
      return responseData.results;
    } else if (Array.isArray(responseData?.data?.results)) {
      return responseData.data.results;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

export const createParticipant = async (participantData) => {
  try {
    const response = await client.post(API_CONFIG.ENDPOINTS.PARTICIPANTS.LIST, participantData);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Le serveur a répondu avec un statut d'erreur
      
      // Si c'est une erreur de validation, afficher les détails
      if (error.response.status === 400 && error.response.data) {
        const errorMessages = [];
        for (const [field, errors] of Object.entries(error.response.data)) {
          if (Array.isArray(errors)) {
            errorMessages.push(`${field}: ${errors.join(', ')}`);
          } else if (typeof errors === 'string') {
            errorMessages.push(errors);
          } else if (typeof errors === 'object') {
            for (const [subField, subErrors] of Object.entries(errors)) {
              if (Array.isArray(subErrors)) {
                errorMessages.push(`${field}.${subField}: ${subErrors.join(', ')}`);
              } else {
                errorMessages.push(`${field}.${subField}: ${subErrors}`);
              }
            }
          }
        }
        
        if (errorMessages.length > 0) {
          error.validationErrors = errorMessages;
        }
      }
    }
    throw error;
  }
};

export const updateParticipant = async (id, participantData) => {
  try {
    const response = await client.put(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.DETAIL}${id}/`, participantData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteParticipant = async (id) => {
  try {
    const response = await client.delete(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.DETAIL}${id}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendInvitation = async (participantId) => {
  try {
    const response = await client.post(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.SEND_INVITE}${participantId}/send-invite/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const assignSurveyToParticipant = async (participantId, surveyId) => {
  try {
    const response = await client.post(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.ASSIGN_SURVEY}${participantId}/assign-survey/`, {
      survey_id: surveyId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ============ PUBLIC PARTICIPATION API ============

export const getParticipation = async (token) => {
  const res = await client.get(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.PARTICIPATION}${token}/`);
  return res.data;
};

export const submitResponses = async (token, answers) => {
  const res = await client.post(`${API_CONFIG.ENDPOINTS.PARTICIPANTS.RESPONSES}${token}/responses/`, { answers });
  return res.data;
};
